import React, { useEffect, useState } from 'react';
import { Col, DatePicker, Form, Input, Modal, notification, Row, Space, Table } from 'antd';
import Button from 'mixins/ui/button/button';
import { IPollData, IQuestionData, IShownComponents, TServiceUrl } from '../express-help.types';
import EditQuestionnaireModal from '../modals/modal-edit-poll';
import Link from 'antd/es/typography/Link';
import BtnReturnBack from '../BtnReturnBack';
import {
    deleteQuestionById,
    getQuestionnaireById,
    getQuestionsByQuestionnaireId,
    searchQuestion,
} from '/react4xp/parts/express-help/actions';

const PollItemScreen = (props: any) => {
    const [data, setData] = useState<IQuestionData[]>([]);
    const [isBeingDeleted, setIsBeingDeleted] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedObject, setSelectedObject] = useState<IQuestionData>();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [questionnaireData, setQuestionnaireData] = useState<IPollData>();

    const [form] = Form.useForm();

    const [pageSize, setPageSize] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [total, setTotal] = useState(0);
    const pageSizeOptions = [5, 10, 20, 50, 100];
    const { confirm } = Modal;

    const serviceType: TServiceUrl = { service: 'Question' };

    const loadQuestion = () => {
        setIsLoading(true);

        getQuestionsByQuestionnaireId(props.showObject.idOfQuestionnaire, {
            page: pageNumber - 1,
            size: pageSize,
        })
            .then((response) => {
                setData(response.data.content);
                setTotal(response.data.totalElements);
            })
            .finally(() => setIsLoading(false));
    };

    const deleteOne = (id: number) => {
        confirm({
            title: 'Подтвердите действия удаления данных',
            onOk() {
                setIsBeingDeleted(true);
                deleteQuestionById(id)
                    .then(() => {
                        notification['success']({
                            message: 'Данные успешно удалены!',
                        });
                        loadQuestion();
                    })
                    .catch(() => {
                        notification['error']({
                            message: 'Ошибка',
                            description:
                                'Невозможно удалить запись. Требуется сначало удалить ответы вопроса', //JSON.stringify(error),
                        });
                    })
                    .finally(() => setIsBeingDeleted(null));
            },
        });
    };

    const edit = (doc: any) => {
        setIsModalOpen(true);
        setSelectedObject(doc);
    };

    const add = (docId: number) => {
        moveToScreen({
            mainPageShown: false,
            pollPageShown: false,
            questionPageShown: false,
            answerPageShown: true,
            idOfQuestionnaire: props.showObject.idOfQuestionnaire,
            idOfQuestion: docId,
            editMode: false,
        });
    };

    const addQuestion = () => {
        moveToScreen({
            mainPageShown: false,
            pollPageShown: false,
            questionPageShown: true,
            answerPageShown: false,
            idOfQuestionnaire: props.showObject.idOfQuestionnaire,
            editMode: false,
        });
    };

    const showQuestionAnswers = (questionId: number) => {
        const nextPageParameter: IShownComponents = {
            mainPageShown: false,
            pollPageShown: false,
            questionPageShown: false,
            questionsAnswersPageShown: true,
            answerPageShown: false,
            idOfQuestion: questionId,
            idOfQuestionnaire: props.showObject.idOfQuestionnaire,
            editMode: true,
        };
        props.showNext(nextPageParameter);
    };

    const onActionClick = (key: string, doc: any) => {
        switch (key) {
            case 'EDIT':
                edit(doc);
                break;
            case 'DELETE':
                deleteOne(doc.id);
                break;
            case 'ADD':
                add(doc.id);
                break;
            case 'SHOW':
                showQuestionAnswers(doc.id);
                break;
        }
    };

    const moveToScreen = (nextScreenParameter: IShownComponents) => {
        props.showNext(nextScreenParameter);
    };

    const handleOk = () => {
        setSelectedObject(null);
        setIsModalOpen(false);
        loadQuestion();
    };

    const handleCancel = () => {
        setSelectedObject(null);
        setIsModalOpen(false);
    };

    const columns = [
        {
            title: 'ИД',
            dataIndex: 'externalQuestionId',
        },
        {
            title: 'Наименование на казахском языке',
            dataIndex: 'questionKk',
        },
        {
            title: 'Наименование на русском языке',
            dataIndex: 'questionRu',
        },
        {
            title: 'Наименование на английском языке',
            dataIndex: 'questionEn',
        },
        {
            title: 'Вес',
            dataIndex: 'questionWeight',
        },
        {
            title: 'Изменил',
            dataIndex: 'username',
        },
        {
            title: 'Действия',
            width: 180,
            render: (text, record) => (
                <span>
                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('DELETE', record);
                        }}
                    >
                        Удалить
                    </Link>

                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('EDIT', record);
                        }}
                    >
                        Редактировать
                    </Link>

                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('SHOW', record);
                        }}
                    >
                        Просмотр
                    </Link>
                </span>
            ),
        },
    ];

    useEffect(() => {
        getQuestionnaireById(props.showObject.idOfQuestionnaire).then((response) => {
            const questionnaire: IPollData = response.data;

            form.setFieldValue('externalQuestionnaireId', questionnaire.externalQuestionnaireId);
            form.setFieldValue('questionnaireRu', questionnaire.questionnaireRu);

            setQuestionnaireData(questionnaire);
        });

        loadQuestion();
    }, []);

    const onReturnBackHandler = () => {
        const nextPageParameter: IShownComponents = {
            mainPageShown: true,
            pollPageShown: false,
            questionPageShown: false,
            answerPageShown: false,
            editMode: false,
        };

        props.showNext(nextPageParameter);
    };

    const onFinish = (values) => {
        const data = {
            ...values,
            questionnaireId: props.showObject.idOfQuestionnaire,
        };

        searchQuestion(data).then((response) => {
            setData(response.data.content);
        });
    };

    const handlePaginationChange = (pagination) => {
        setPageNumber(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const resetForm = () => {
        form.resetFields();
        loadQuestion();
    };

    useEffect(() => {
        loadQuestion();
    }, [pageNumber, pageSize]);

    return (
        <div className="poll-screen">
            <BtnReturnBack handler={onReturnBackHandler} />

            <h4 className="my-3">Вопросы</h4>

            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                className="my-3"
            >
                <Row gutter={{ xs: 8, md: 16 }}>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="username"
                            label="Изменил"
                        >
                            <Input placeholder="Введите" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="changeDateFrom"
                            label="Дата изменения C"
                        >
                            <DatePicker picker="date" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="changeDateTo"
                            label="По"
                        >
                            <DatePicker picker="date" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="question"
                            label="Наименование на русском"
                        >
                            <Input placeholder="Введите" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={{ xs: 8, md: 12 }}>
                    <Col
                        xs={24}
                        md={12}
                        className="d-flex justify-content-start"
                    >
                        <Space wrap>
                            <Button onClick={resetForm}>Сброс</Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                color="gold"
                            >
                                Поиск
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>

            <div className="poll-screen__table-header">
                <Row gutter={{ xs: 24, md: 24 }}>
                    <Col
                        xs={24}
                        md={12}
                    >
                        <h4 className="poll-screen-list">Список вопросов</h4>
                    </Col>
                    <Col
                        xs={24}
                        md={12}
                        className="d-flex justify-content-end"
                    >
                        <Button
                            color="gold"
                            onClick={addQuestion}
                        >
                            Создать вопрос
                        </Button>
                    </Col>
                </Row>
            </div>

            <Table
                className="my-3"
                dataSource={data}
                columns={columns}
                loading={isLoading}
                pagination={{
                    current: pageNumber,
                    pageSize,
                    total,
                    showSizeChanger: true,
                    pageSizeOptions,
                }}
                scroll={{
                    x: true,
                }}
                onChange={handlePaginationChange}
            />

            <EditQuestionnaireModal
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
                selectedObject={selectedObject}
                selectedType={serviceType}
            />
        </div>
    );
};

export default PollItemScreen;
